import React from "react";
import { Outlet } from "react-router-dom";
import Login from "../pages/login";

const useAuth = () => {
  if (sessionStorage.getItem("atkn") || localStorage.getItem("atkn")) {
    return true;
  }
};

export const ProtectedRoutes = () => {
  const isAuth = useAuth();
  return isAuth ? <Outlet /> : <Login />;
};
